import * as React from 'react'
import { InsuredInformationBreadcrumb } from 'quick-quote/components'
import RiderGroup from 'quick-quote/product-common/coverage-plan/components/rider/rider-group'

import { ModelFactorSelection } from 'quick-quote/product-common/coverage-plan/components/basic-plan/model-factor-selection'
import { BasicPlan } from 'quick-quote/product-common/coverage-plan/components/basic-plan/basic-plan'
import BasicPlanSelection from './basic-plan-selection'
import { TotalPremiumInput } from 'quick-quote/product-common/coverage-plan/components/basic-plan/total-premium-input'
import PATH from 'quick-quote/constants/path'
import { Redirect } from 'react-router-dom'

class CoveragePlan extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.props.validateBasicPlan()
  }

  render() {
    const props = this.props
    if (!props.hasProductSelected) {
      return <Redirect to={PATH.PRODUCT_SELECTION} push />
    }
    return (
      <div>
        <InsuredInformationBreadcrumb />
        <div id="coverage-plan">
          <div className="content">
            <div id="basic-plan">
              <div className="content">
                <ModelFactorSelection
                  modelFactors={props.modelFactors}
                  selectedModelFactorID={props.selectedModelFactorID}
                  selectModelFactor={props.selectModelFactor}
                />
                <BasicPlanSelection
                  basicPlanOptions={props.basicPlanOptions}
                  selectedBasicPlanCode={props.selectedBasicPlanCode}
                  basicPlanValidationError={props.basicPlanValidationError}
                  editSelectedHealthPlan={props.updateSelectedBasicPlan}
                />
                <BasicPlan
                  basicPremiumState={props.basicPremiumState}
                  haveBasicPremiumState={props.haveBasicPremiumState}
                  sumAssured$={props.sumAssured$}
                  basicPremium$={props.basicPremium$}
                  readOnlyFields={props.readOnlyFields}
                  editSumAssured={props.editSumAssured}
                  editBasicPremium={props.editBasicPremium}
                />
              </div>
            </div>
            <div id="total-premium">
              <TotalPremiumInput
                totalPremium$={props.totalPremium$}
                riderCodes={props.riderCodes}
                editTotalPremium={props.editTotalPremium}
              />
            </div>
            <RiderGroup
              riderCodes={props.riderCodes}
              toggleRider={props.toggleRider}
              editRiderSumAssured={props.editRiderSumAssured}
              editRiderSelectedPlan={props.editRiderSelectedPlan}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default CoveragePlan
